import axios from './index'

export default {
  getCustomer(customerId) {
    return axios.get('/Prescription/GetCustomer?id=' + customerId)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  },
  searchDrugs(model) {
    return axios.post('/Prescription/SkrsDrugSearch', model)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  },
  searchSuts(model) {
    return axios.post('/Prescription/SkrsSutSearch', model)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  },
  getPrescriptionTypes() {
    return axios.get('/Prescription/GetSaglikNetPrescriptionTypes')
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  },
  getInsuranceTypes() {
    return axios.get('/Prescription/GetInsuranceType')
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  },
  getProvisionTypes() {
    return axios.get('/Prescription/GetProvisionType')
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  },
  getPrescriptionSubTypes() {
    return axios.get('/Prescription/GetPrescriptionSubType')
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  },
  getDrugUsageMethods(prescriptionType) {
    return axios.get('/Prescription/GetSaglikNetDrugUsageMethod?prescriptionTypes=' + prescriptionType)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  },
  getMedicalDeviceUsageLocations() {
    return axios.get('/Prescription/GetMedicalDeviceUsageLocation')
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  },
  getPeriods() {
    return axios.get('/Prescription/GetSaglikNetPeriods')
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  },
  getStaffList() {
    return axios.get('/staff/listJson')
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  },
  submitPrescription(model) {
    return axios.post('/Sagliknet/NewPrescription', model)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}
